const AUTH_REDIRECT_IN_PROGRESS_KEY = 'authRedirectInProgress'

export const isAuthRedirectInProgress = (): boolean =>
  sessionStorage.getItem(AUTH_REDIRECT_IN_PROGRESS_KEY) === 'true'

export const markAuthRedirectInProgress = (): void => {
  sessionStorage.setItem(AUTH_REDIRECT_IN_PROGRESS_KEY, 'true')
}

export const clearAuthRedirectInProgress = (): void => {
  sessionStorage.removeItem(AUTH_REDIRECT_IN_PROGRESS_KEY)
}
